<div class="mr-static mr-layout leaflet-maps-layout">
  <div class="mr-static__top">
    <h1 class="mr-static__title mr-generated-title-WP">Tabula imaginaria</h1>
  </div>
  <div class="mr-static__content leaflet-maps-layout__maps-container">
    <div class="leaflet-maps-layout__map-item">
      <iframe
        src="/assets/maps/mapa_interactivo_sferamundi_13_1.html"
        frameborder="0"
        class="leaflet-maps-layout__iframe">
      </iframe>
    </div>
    <div class="leaflet-maps-layout__map-item">
      <iframe
        src="/assets/maps/mapa_interactivo_sferamundi_13_2.html"
        frameborder="0"
        class="leaflet-maps-layout__iframe">
      </iframe>
    </div>
    <div class="leaflet-maps-layout__map-item">
      <iframe
        src="/assets/maps/mapa_interactivo_sferamundi_13_3.html"
        frameborder="0"
        class="leaflet-maps-layout__iframe">
      </iframe>
    </div>
    <div class="leaflet-maps-layout__map-item">
      <iframe
        src="/assets/maps/mapa_interactivo_sferamundi_13_4.html"
        frameborder="0"
        class="leaflet-maps-layout__iframe">
      </iframe>
    </div>
    <div class="leaflet-maps-layout__map-item">
      <iframe
        src="/assets/maps/mapa_interactivo_sferamundi_13_5.html"
        frameborder="0"
        class="leaflet-maps-layout__iframe">
      </iframe>
    </div>
    <div class="leaflet-maps-layout__map-item">
      <iframe
        src="/assets/maps/mapa_interactivo_sferamundi_13_6.html"
        frameborder="0"
        class="leaflet-maps-layout__iframe">
      </iframe>
    </div>
  </div>
</div>
